// extracted by mini-css-extract-plugin
export default {"productGallery":"XP-z","inQuickShop":"YP-z"};